export const overviewSelector = {
    storekey: "_ovstk",
};
